import React, { Component } from 'react';
import axios from 'axios';
import EditMember from '../CommonComponent/EditMember';
import { connect } from 'react-redux';


import {
  ActiveListsetEdit,
  onCityLocation1,
  allMember,
} from '../../Redux/action/memberAction';
import { dataUser, dataLocation } from '../Helpers/util';
import mixpanel from 'mixpanel-browser';
import moment from 'moment';
import { toast } from 'react-toastify';
import axiosInstance from '../../utils/axiosInstance';
import SwButton from '../Common/SwButtons/SwButtons';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';

var FormData = require('form-data');
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);

class MainCommonDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pgno: this.props.pg,
      footerState: null,
      showEditMember: false,
      row: this.props.rw,
      setIndex: 0,
      items: {},
      loader: false,
      fnameerrorMsg: '',
      lnameerrorMsg: '',
      email_iderrorMsg: '',
      phone_noerrorMsg: '',
      nfileerrorMsg: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      locationNew: {},
      testRec: '',
    };
        this.editMemberRef = React.createRef();
  }

  btnClick() {

    mixpanel.track('Member Management Page View', {
      PageName: 'Members',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Members',
      TotalMembers: this.props.activeUserList.userList.total,
      ActiveMembers: this.props.activeUserList.userList.active,
      InactiveMembers: this.props.activeUserList.userList.inactive,
      TotalSPOCs: this.props.activeUserList.userList.spoc,
    });
  }
    closeAddMember = () => {
    this.setState({ showEditMember: false });
  };

  onFooterState = footerState => {
  this.setState({ footerState });
};

  changeforward = () => {
    this.setState({
      setIndex: this.state.setIndex + 1,
      loader: true,
    });
    var itemIndex = this.state.items[this.state.setIndex + 1];
    var singleId = itemIndex.rec_id;
    let parm = {
      rec_id: singleId,
    };
    this.props.ActiveListsetEdit(parm);
  };
  changebackformward = () => {
    this.setState({
      setIndex: this.state.setIndex - 1,
      loader: true,
    });
    var itemIndex = this.state.items[this.state.setIndex - 1];
    var singleId = itemIndex.rec_id;
    let parm = {
      rec_id: singleId,
    };
    this.props.ActiveListsetEdit(parm);
  };

  sendId = (rcid, email, i, list) => {
    let parm = {
      rec_id: rcid,
      email: email,
    };
    this.setState({
      setIndex: i,
      items: list,
    });
    this.props.ActiveListsetEdit(parm);
    mixpanel.track('Member Management Edit', {
      PageName: 'Members',
      UserEmail: UserObj?.email,
      UserName: UserObj?.fname + ' ' + UserObj?.lname,
      UserId: UserObj?.rec_id,
      CompanyId: UserObj?.company_id,
      CompanyName: UserObj?.company_name,
      Type: 'Members',
      FirstName: list?.fname,
      LastName: list?.lname,
      EmployeeCode: list?.emp_code,
      PhoneNumber: list?.phone,
      CorporateEmail: list?.email,
      BloodGroup: list?.blood_group,
      Vaccination: list?.vaccinated,
      City: list?.city_name,
      Building: list?.business_name,
      Floor: list?.floor_name,
      EmployeeDepartment: list?.dept_name,
    });
  };

  getDelete = async userId => {
    try {
      // Retrieve organization data from localStorage
      const organizationData = JSON.parse(localStorage.getItem('headData'));
      if (!organizationData) {
        toast.error('Organization data not found in local storage.');
        return;
      }

      // Make the DELETE API call
      const res = await axiosInstance.delete(
        `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/${userId}`,
        {
          headers: {
            // Replace with actual token retrieval logic
            'req-organization-id': organizationData.organizationId,
            'req-organization-type': organizationData.roomShared,
          },
        },
      );

      if (res.status === 200) {
        toast.success(res.data.message, {});

        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        toast.error(res.data.message, {});
      }
    } catch (error) {
      // Error handling
      toast.error('An error occurred while deleting the user.');
      console.error('Error deleting user:', error);
         const errorMessage =
            error.response?.data?.data?.error ||
            error.response?.data?.message ||
            'An unexpected error occurred. Please try again.';
      
          toast.error(errorMessage);
    }
  };

  componentDidMount() {
    this.btnClick();
    this.props.onCityLocation1({
      location: LocationObj,
    });
    let authToken = JSON.parse(localStorage.getItem('headData'));
    axios
      .get(`${process.env.REACT_APP_API_URL}basic-data/get-all-locations`, {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      })
      .then(res => {
        if (res.data.status == 'success') {
          this.setState({ locationNew: res.data.data });
        }
      });
  }

  componentWillReceiveProps(props) {
    if (props.activeUserList.userList != 0) {
      this.setState({
        items:
          props.activeUserList.userList && props.activeUserList.userList.list,
        loader: false,
      });
    }
  }

  locationNameById = (locationsData, locationId) => {
    if (Object.keys(locationsData).length > 0) {
      let locationName = locationsData?.filter(
        item => locationId == item.rec_id,
      );
      if (locationName?.length > 0) {
        return locationName[0].location_short_code;
      } else {
        return '-';
      }
    }
  };

  render() {
    const activeUserList = this.props.activeUserList.userList;

    const ManageMembers = this.state.userRole.find(
      element => element.service_id == '1',
    );
    const ManageApproval1 = this.state.userRole.find(
      element => element.service_id == '23',
    );
    return (
      <>
        {(ManageMembers && ManageMembers.role_for_write == '1' ? (
          true
        ) : (
          false || (ManageApproval1 && ManageApproval1.role_for_write == '1')
        )) ? (


    

        <SwOffCanvas
  show={this.state.showEditMember}
  onClose={() => this.setState({ showEditMember: false })}
  title="Edit New Member"
  placement="end"
  backdrop="static"
  keyboard={false}
 footer={
  (() => {
    const fs = this.state.footerState;
    if (!fs) return null;

    const {
      isApproved1,
      isApproved,
      ManageApproval1,
      ManageMembers,
      btnStatus,
    } = fs;

    return isApproved1 == 1 &&
      isApproved === 0 &&
      ((ManageApproval1 &&
        ManageApproval1.role_for_write == '1') ||
        ManageApproval1?.role_for_read == '1') ? (

      /* ===== APPROVAL FOOTER ===== */
      <div className="OffCanvasFooter_Btns">
        <SwButton
          disabled={ManageApproval1?.role_for_write != '1'}
          variant='dark-outline'
          onClick={() =>
            this.editMemberRef.current?.handleShowDeny()
          }
        >
          Deny Request
        </SwButton>

        <SwButton
          variant='primary'
          disabled={ManageApproval1?.role_for_write != '1'}
          onClick={() =>
            this.editMemberRef.current?.handleShowGrant()
          }
        >
          Grant Access
        </SwButton>
      </div>
    ) : (

      /* ===== NORMAL EDIT FOOTER ===== */
      <div className="OffCanvasFooter_Btns">
        <SwButton
          variant="dark-outline"
          onClick={() =>
            this.editMemberRef.current?.reload()
          }
        >
          Reset
        </SwButton>

        {!btnStatus ? (
          <SwButton
            variant="primary"
            className="ml10"
            disabled={ManageMembers?.role_for_write != '1'}
            onClick={e =>
              this.editMemberRef.current?.EditSubmit(e)
            }
          >
            Update
          </SwButton>
        ) : (
          <SwButton variant="dark" disabled className="ml10">
            <i className="fa fa-refresh fa-spin" /> Processing
          </SwButton>
        )}
      </div>
    );
  })()
}
>
<EditMember
  ref={this.editMemberRef}
  onFooterState={this.onFooterState}
  onClose={this.closeEditMember}
  onSuccess={this.closeAddMember}
  epg={this.state.pgno}
  erw={this.state.row}
/>
</SwOffCanvas>



          
        ) : (
          ''
        )}

        <div className="commonTable MemberAccessTable">
          {activeUserList.list != '' ? (
            <table className="table customeTable">
              <thead>
                <tr className="noborderHeader">
                  <th>
                    <span
                      style={{ width: '12px', display: 'inline-block' }}
                      className="pr-1"
                    >
                      &nbsp;
                    </span>
                    Name
                  </th>
                  <th>Corporate Email</th>
                  <th>Phone</th>
                  <th>Building Location</th>
                  {UserObj?.company_id != process.env.REACT_APP_TALBOT_COM_ID &&
                  UserObj?.company_id != process.env.REACT_APP_PROZO_COM_ID ? (
                    <th>Last Active On App</th>
                  ) : (
                    ''
                  )}
                  <th>Department</th>
                  <th>Status</th>
                
                    <th>Edit</th>
               
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {activeUserList.list !== 0
                  ? activeUserList.list &&
                    activeUserList.list &&
                    activeUserList.list.map((list, i) => (
                      <tr>
                        <td className="capitalCase dataFont">
                          <div className='MemberAccessName'>
                            {list.utype == 1 ? (
                              <span className="pr-1">
                                <span class="custom-tooltip3 Customtooltiptext3">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <g clip-path="url(#clip0_200_1483)">
                                      <path
                                        d="M10.6624 4.79824C10.4524 4.30059 10.3518 4.05 10.133 3.56294L10.5883 2.60647L9.3865 1.41177L8.44238 1.8653C7.95003 1.6553 7.69944 1.55471 7.20708 1.34471L6.85061 0.352943H5.14944L4.7965 1.33765C4.29708 1.54765 4.0465 1.64824 3.5612 1.85824L2.61355 1.41177L1.41179 2.60647L1.86532 3.55765C1.65532 4.05 1.55473 4.30059 1.34473 4.79294L0.352966 5.14941V6.85059L1.33767 7.20353C1.54767 7.70294 1.64826 7.95353 1.85826 8.43883L1.41179 9.38647C2.01355 9.99353 2.01355 9.99353 2.62061 10.5953L3.56473 10.1418C4.05708 10.3518 4.30767 10.4524 4.80003 10.6712L5.15297 11.6559H6.85414L7.20708 10.6712C7.70473 10.4612 7.95532 10.3606 8.44238 10.1418L9.3865 10.5882C9.99355 9.98647 9.99355 9.98647 10.5953 9.37941L10.1418 8.4353C10.3518 7.94294 10.4524 7.69236 10.6712 7.2L11.6559 6.84706V5.14941L10.6624 4.79824ZM6.00003 9.04765C5.39683 9.04765 4.80719 8.86876 4.30568 8.53361C3.80417 8.19846 3.41332 7.7221 3.18257 7.16479C2.95182 6.60748 2.89153 5.99425 3.00934 5.40268C3.12714 4.8111 3.41775 4.26775 3.84439 3.84135C4.27103 3.41496 4.81455 3.12467 5.4062 3.0072C5.99784 2.88974 6.61103 2.95038 7.16821 3.18146C7.72538 3.41253 8.20152 3.80365 8.53638 4.30536C8.87124 4.80706 9.04979 5.39681 9.04944 6C9.04897 6.80845 8.72749 7.58363 8.15566 8.15512C7.58384 8.72662 6.80847 9.04765 6.00003 9.04765V9.04765Z"
                                        fill="#808080"
                                      />
                                      <path
                                        d="M7.98002 7.17C7.75559 7.48613 7.45872 7.74393 7.11425 7.92183C6.76978 8.09973 6.38772 8.19256 6.00002 8.19256C5.61232 8.19256 5.23026 8.09973 4.88579 7.92183C4.54132 7.74393 4.24445 7.48613 4.02002 7.17C4.19077 6.64882 4.56057 6.21623 5.04884 5.96647C5.32803 6.16064 5.65995 6.26471 6.00002 6.26471C6.33983 6.26486 6.6714 6.16008 6.94943 5.96471C7.43909 6.21405 7.80976 6.64755 7.98002 7.17V7.17Z"
                                        fill="#808080"
                                      />
                                      <path
                                        d="M6.93177 4.73824C6.93211 4.9226 6.87776 5.10292 6.77559 5.25638C6.67342 5.40984 6.52802 5.52954 6.3578 5.60033C6.18757 5.67113 6.00017 5.68983 5.81931 5.65408C5.63845 5.61832 5.47226 5.52972 5.34177 5.39948C5.21128 5.26924 5.12237 5.10322 5.08627 4.92243C5.05018 4.74164 5.06852 4.5542 5.13899 4.38384C5.20947 4.21348 5.32889 4.06785 5.48216 3.96539C5.63542 3.86293 5.81564 3.80824 6 3.80824C6.12228 3.808 6.2434 3.83189 6.35644 3.87852C6.46948 3.92515 6.57221 3.99362 6.65875 4.08C6.7453 4.16638 6.81396 4.26899 6.86081 4.38193C6.90765 4.49488 6.93177 4.61596 6.93177 4.73824Z"
                                        fill="#808080"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_200_1483">
                                        <rect
                                          width="12"
                                          height="12"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <span class="Customtooltiptext3">
                                    {list.role_name}
                                  </span>
                                </span>
                              </span>
                            ) : (
                              <span
                                style={{ width: '12px', display: 'inline-block' }}
                                className="pr-1"
                              >
                                &nbsp;
                              </span>
                            )}
                            <span>{list.fname} {list.lname}</span>
                          </div>
                        </td>
                        <td>{list.email}</td>
                        <td>{list.phone}</td>
                        <td className="capitalCase">
                          {list.floor_name},{' '}
                          {this.locationNameById(
                            this.state.locationNew,
                            list.location_id,
                          )}
                        </td>

                        {UserObj?.company_id !=
                          process.env.REACT_APP_TALBOT_COM_ID &&
                        UserObj?.company_id !=
                          process.env.REACT_APP_PROZO_COM_ID ? (
                          <td>
                            {list.lastActivity == null
                              ? '-'
                              : moment
                                  .unix(list.lastActivity)
                                  .format('YYYY-MM-DD HH:mm:ss')}
                          </td>
                        ) : (
                          ''
                        )}
                        <td>
                          {list.dept_name != null && list.dept_name != ''
                            ? list.dept_name
                            : 'N/A'}
                        </td>

                        <td className="statusRelate">
                          {list.is_active == 1 &&
                          list.isSpocApproved == 0 &&
                          ((ManageMembers &&
                            ManageMembers.role_for_write == '1') ||
                            ManageMembers?.role_for_read == '1') ? (
                            <button
                              disabled={
                                !(ManageApproval1 &&
                                ManageApproval1?.role_for_write == '1')
                              }
                              className="btn btn-primary btn-sm custom-tooltip memberApprovalBtn"
                              data-toggle="modal"
                              data-target="#myModal3"
                              //   className="pointerCursor pulse"
                              key={i}
                              onClick={() =>
                                this.sendId(list.rec_id, list.email, i, list)
                              }
                            >
                              {' '}
                              Decide{' '}
                              <span className="Customtooltiptext">
                                Forbidden Access
                              </span>
                            </button>
                          ) : list.is_active == 1 &&
                            list.isSpocApproved == 1 ? (
                            <div className="text-success">Has access</div>
                          ) : list.is_active == 1 &&
                            list.isSpocApproved == 2 ? (
                            <div className="text-danger">No access</div>
                          ) : list.is_active == 0 &&
                            list.isSpocApproved == 1 ? (
                            <div className="text-danger">No access</div>
                          ) : (
                            <div className="text-danger">No access</div>
                          )}
                        </td>

                     <td
  // data-toggle="modal"
  // data-target="#myModal3"
  className="pointerCursor pulse"
  key={i}
  onClick={() => {
    this.sendId(list.rec_id, list.email, i, list);
    this.setState({ showEditMember: true });
  }}
>
                            {!(
                              list.is_active === 1 && list.isSpocApproved === 0
                            ) && (
                              <i className="fa fa-pencil" aria-hidden="true" />
                            )}
                            &nbsp;&nbsp;
                          </td>
                     
                        <td>
                          {(list.is_active == 1 && list.isSpocApproved == 2) ||
                          (list.is_active == 0 && list.isSpocApproved == 1) ? (
                            <i
                              className="fa fa-trash"
                              style={{ color: 'red' }}
                              aria-hidden="true"
                              data-toggle="modal"
                              data-target="#deleteUserList"
                              type="button"
                              onClick={() =>
                                this.setState({ testRec: list.rec_id })
                              }
                            />
                          ) : (
                            ''
                          )}
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          ) : (
            <div className="Nodata">
              <img src="img/no-data-found-img-red.png" />
            </div>
          )}
        </div>

        <div className="MAccessCard_Container">
          {/* Show Loader if Data is Not Yet Fetched */}
          {activeUserList?.list === undefined ? (
            <div className="LoadingState">Loading...</div>
          ) : activeUserList.list.length > 0 ? (
            activeUserList.list.map((list, i) => (
              <div key={i} className="MAccessCard">
                <div className='MAccessCard_Left'>
                  <div className="MemberName">{list.fname} {list.lname}</div>
                  <div className="MemberEmail">{list.email}</div>
                  <div className="MemberNumber">{list.phone || "N/A"}</div>
                </div>

                <div className='MAccessCard_Right'>
                  <div className="MemberAccessStatus">
                    {list.is_active == 1 && list.isSpocApproved == 0 &&
                      ((ManageMembers && ManageMembers.role_for_write == '1') ||
                        ManageMembers?.role_for_read == '1') ? (
                      <button
                        disabled={!(ManageApproval1 && ManageApproval1?.role_for_write == '1')}
                        className="btn btn-primary btn-sm custom-tooltip memberApprovalBtn"
                        data-toggle="modal"
                        data-target="#myModal3"
                        onClick={() => this.sendId(list.rec_id, list.email, i, list)}
                      >
                        Decide <span className="Customtooltiptext">Forbidden Access</span>
                      </button>
                    ) : list.is_active == 1 && list.isSpocApproved == 1 ? (
                      <div className="text-success">Has access</div>
                    ) : (
                      <div className="text-danger">No access</div>
                    )}
                  </div>
                  <div className="MemberAction">
                    {!(
                      list.is_active === 1 && list.isSpocApproved === 0
                    ) && (
                      <button data-toggle="modal" data-target="#myModal3" className='btn '
                        onClick={() => this.sendId(list.rec_id, list.email, i, list)}
                      >
                        <i className="fa fa-pencil" aria-hidden="true" />
                      </button>
                    )}

                    {(list.is_active == 1 && list.isSpocApproved == 2) ||
                      (list.is_active == 0 && list.isSpocApproved == 1) ? (
                      <button data-toggle="modal" data-target="#deleteUserList" className='btn Delete'
                        onClick={() => this.setState({ testRec: list.rec_id })}
                      >
                        <i className="fa fa-trash" aria-hidden="true" />
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="Nodata">
              <img src="img/no-data-found-img-red.png" alt="No Data" />
            </div>
          )}
        </div>


    

        <div
          className=" modal fade qrModel BBBB "
          id="deleteUserList"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content ">
              <div className="formTitle">
                <p>Alert !! </p>
                <button
                  type="button"
                  className="relateDox close"
                  data-dismiss="modal"
                >
                  x
                </button>
              </div>
              <div className="modal-body">
                <div className="qrScannerMain bb">
                  <div className="row">
                    <div className="col-md-12 ">
                      <p id="modalText">
                        Are you sure you want to delete this user's requestSDFGHJKL ?
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button className="btn btn" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  className="btn btn-success"
                  data-dismiss="modal"
                  onClick={() => this.getDelete(this.state.testRec)}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  activeUserList: state.activeUserList,
});
const mapActionsToProps = {
  ActiveListsetEdit,
  onCityLocation1,
  allMember,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(MainCommonDataTable);
